import cx from 'classnames';
import { forwardRef } from 'react';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { ConditionalView } from '../../utils/ConditionalView';
import { WrapTextNodes } from '../../utils/WrapTextNodes';
import styles from './RadioButton.module.scss';
import type { RadioButtonProps } from './RadioButton.types';

const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>((props: RadioButtonProps, ref) => {
  const {
    className,
    size = 'Medium',
    checked,
    disabled = false,
    invalid = false,
    labelAlignment = 'Left',
    value,
    children,
    onChange,
    ...otherInputProps
  } = props;

  const variantProps = useBuildVariantProps(
    'radio-button',
    {
      size,
      style: checked ? 'Selected' : 'Unselected',
    },
    {
      disabled,
      invalid,
    },
  );

  return (
    <label
      className={cx(
        styles.radioButton,
        className,
        {
          [styles.labelLeft]: labelAlignment === 'Left',
          [styles.labelRight]: labelAlignment === 'Right',
          [styles.disabled]: disabled,
        },
      )}
      {...variantProps}
    >
      <input
        {...otherInputProps}
        type="radio"
        className={styles.input}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        ref={ref}
        value={value}
      />
      <div className={styles.iconWrapper}>
        <div className={styles.radio}>
          <div className={styles.dot} />
        </div>
      </div>
      <ConditionalView condition={children}>
        <WrapTextNodes className={styles.text}>
          {children}
        </WrapTextNodes>
      </ConditionalView>
    </label>
  );
});

export default RadioButton;